<section class="px-xs !py-lg h-full bg-white" hlmCard>
  <div class="px-md flex items-center justify-between">
    <h3 hlmCardTitle>Liste des modalités</h3>
    <div hlmCardAction>
      <button (click)="ajouterModalite()" hlmBtn variant="secondary">
        <ng-icon name="lucidePlus" />
        Ajouter une modalité
      </button>
    </div>
  </div>
  <div class="gap-xl grid" hlmCardContent>
    <div hlmTableContainer>
      <table hlmTable>
        <thead hlmTHead>
          <tr hlmTr>
            <th hlmTh>Nom de la modalité</th>
            <th hlmTh>Actions</th>
          </tr>
        </thead>
        <tbody hlmTBody>
          @for (modalite of modalites() | trierPar: 'nom'; track modalite.id) {
            <tr hlmTr>
              <td class="flex items-center" hlmTd>
                <span>{{ modalite.nom }}</span>
              </td>
              <td hlmTd>
                <button
                  [hlmDropdownMenuTrigger]="menu"
                  [hlmDropdownMenuTriggerData]="{ $implicit: modalite }"
                  (click)="$event.stopPropagation()"
                  hlmBtn
                  variant="ghost"
                  size="icon"
                >
                  <ng-icon name="lucideEllipsisVertical" />
                </button>
              </td>
            </tr>
          } @empty {
            <tr hlmTr>
              <td hlmTd colspan="2">Aucune modalité</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <app-paginateur [store]="store" />
  </div>

  <ng-template #menu let-ctx>
    <hlm-dropdown-menu>
      <hlm-dropdown-menu-group>
        <button (triggered)="modifierModalite(ctx)" hlmDropdownMenuItem>
          <ng-icon hlm name="lucidePen" size="sm" />
          Modifier la modalité
        </button>
        <button (triggered)="supprimerModalite(ctx)" hlmDropdownMenuItem>
          <ng-icon hlm name="lucideTrash" size="sm" />
          Supprimer la modalité
        </button>
      </hlm-dropdown-menu-group>
    </hlm-dropdown-menu>
  </ng-template>
</section>
